import { render, staticRenderFns } from "./modalEditDashboardAnnouncements.vue?vue&type=template&id=6e8b2a07&"
import script from "./modalEditDashboardAnnouncements.vue?vue&type=script&lang=js&"
export * from "./modalEditDashboardAnnouncements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports